import {useDebugValue, useEffect} from 'react'

/**
 * Sets the title of the document. Restores the previous document title on unmount.
 *
 * @param title The document title. If `null`, no title will be set.
 *
 * @see https://tacklebox.beta-p.kensho.com/useDocumentTitle
 */
export default function useDocumentTitle(title: string | null): void {
  useDebugValue(title)

  useEffect(() => {
    if (title === null) return undefined

    const prevDocumentTitle = document.title
    document.title = title
    return () => {
      document.title = prevDocumentTitle
    }
  }, [title])
}
